// WHSL THEME JS
// Mobile menu toggle, cart quantity updates, and small UI helpers.

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Mobile menu ---------- */
  var menu = document.getElementById('whsl-mobile-menu');
  var openBtn = document.getElementById('whsl-menu-open');
  var closeBtn = document.getElementById('whsl-menu-close');

  function openMenu() {
    if (menu) menu.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    if (menu) menu.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  if (openBtn) openBtn.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (menu) {
    menu.addEventListener('click', function (e) {
      if (e.target === menu) closeMenu();
    });
  }

  /* ---------- Cart quantity steppers (cart page) ---------- */
  document.querySelectorAll('[data-whsl-qty-decrease]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      input.value = Math.max(0, val - 1);
    });
  });
  document.querySelectorAll('[data-whsl-qty-increase]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      var val = parseInt(input.value, 10) || 0;
      input.value = val + 1;
    });
  });

  /* ---------- Product image gallery (product page) ---------- */
  var thumbs = document.querySelectorAll('[data-whsl-thumb]');
  var mainImg = document.querySelector('[data-whsl-main-image]');
  if (mainImg && thumbs.length) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full-src');
        if (src) mainImg.setAttribute('src', src);
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }
});
